import SectionHeadingStyle3 from '../../SectionHeading/SectionHeadingStyle3';
import VideoBlock from '../../VideoBlock';
import Button from '../../Button';
import { Icon } from '@iconify/react';

export default function AboutUsSection({
  thumbUrl,
  experienceBgUrl,
  experienceIconUrl,
  experienceNumber,
  experienceTitle,
  sectionTitleUp,
  sectionTitle,
  sectionSubTitle,
  grothTitle,
  grothPercentage,
  featureList,
  btnText,
  btnUrl,
  videoBtnText,
  videoBtnUrl,
}) {
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 cs_mb_lg_55">
            <div className="cs_experience cs_style_1 position-relative">
              <div className="cs_experience_thumb">
                <img
                  src={thumbUrl}
                  alt="Thumb"
                  className="position-relative cs_zindex_3 cs_rounded_15"
                />
                <div className="cs_experience_shape">
                  <img
                    src="/images/experience_shape_1.png"
                    alt="Shape"
                    className="moving_x"
                  />
                </div>
              </div>
              <div
                className="cs_experience_box background-filled text-center bg-white cs_rounded_10 position-absolute bottom-0 end-0 cs_zindex_3 d-flex flex-column justify-content-center align-items-center"
                style={{
                  backgroundImage: `url(${experienceBgUrl})`,
                }}
              >
             
              
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="cs_about cs_style_1">
              <SectionHeadingStyle3
                sectionTitleUp={sectionTitleUp}
                sectionTitle={sectionTitle}
                sectionSubTitle={sectionSubTitle}
                className={'cs_mb_15'}
              />
              <div className="cs_progressbar cs_style_1 cs_mb_20">
                <div className="cs_progressbar_heading d-flex justify-content-between align-items-center cs_mb_8">
                  <h3 className="fw-medium m-0 cs_fs_18">{grothTitle}</h3>
                  <p className="cs_fs_14 cs_lh_base m-0">{grothPercentage}%</p>
                </div>
                <div className="cs_progress cs_rounded_8 overflow-hidden">
                  <div
                    className="cs_progress_in bg-accent cs_rounded_8 h-100"
                    style={{
                      width: `${grothPercentage}%`,
                    }}
                  />
                </div>
              </div>
              <div className="row cs_mb_15">
                {featureList?.map((item, index) => (
                  <div className="col-lg-6" key={index}>
                    <div className="cs_about-icon-box position-relative cs_mb_25">
                      <span className="position-absolute cs_height_20 cs_width_20 top-0 start-0 cs_mt_5 bg-accent text-white cs_fs_10 d-flex align-items-center justify-content-center cs_rounded_30">
                        <Icon icon="fa6-solid:angles-right" />
                      </span>
                      <h3 className="cs_fs_16 cs_pl_35 cs_mb_12 cs_lh_lg">
                        {item.title}
                      </h3>
                      <p className="m-0">{item.subTitle}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex align-items-center cs_row_gap_20 cs_column_gap_30 cs_column_gap_lg_20 flex-wrap">
                <Button btnText={btnText} btnUrl={btnUrl} />
           
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
